/**
 * Strict Phone Number Validator for US/NANP Phone Numbers.
 * Rejects letters, emails, non-digit strings, dummy numbers, and invalid area codes.
 */
export const validatePhone = (phone) => {
  if (!phone || typeof phone !== 'string') return false;

  // Rejects any letters or special symbols that are definitely not phone characters
  if (/[a-zA-Z@!#$%^&*<>=_~]/.test(phone)) return false;

  // Clean all non-digit characters
  const clean = phone.replace(/\D/g, '');

  // Handle optional leading US country code 1 (11 digits total)
  const normalized = clean.length === 11 && clean.startsWith('1') ? clean.slice(1) : clean;

  // Must be exactly 10 digits
  if (normalized.length !== 10) return false;

  // NANP Rule: Area code (digit 1) and Central Office Code (digit 4) must be 2-9
  if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(normalized)) return false;

  // Reject obvious fake/repeated numbers (e.g. 0000000000, 1111111111, 9999999999)
  if (/^(\d)\1{9}$/.test(normalized)) return false;

  return true;
};

/**
 * Format US Phone Number cleanly as (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (value) => {
  if (!value) return '';
  // Strip non-digits
  const clean = value.replace(/\D/g, '');
  const digits = clean.startsWith('1') && clean.length > 10 ? clean.slice(1, 11) : clean.slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};